import theme from '@/constants/theme';
import { Check } from '@mui/icons-material';
import React from 'react';
import styles from './styles';
import './blink.css';

interface Props {
  autoSave: boolean;
}

const AutosaveIndicator: React.FC<Props> = ({ autoSave }) => {
  return (
    <div style={styles.container}>
      <p style={{ color: theme.colors.text.caption }}>Guardado automátcio</p>
      <div>
        {autoSave && (
          <div style={styles.saved} className='blink'>
            <Check width={20} height={20} style={{ color: "inherit" }} />
            <p style={{ color: "inherit" }}>Guardado</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutosaveIndicator;
